// extracted by mini-css-extract-plugin
module.exports = {"container":"antd-pro-components-table-widgets-image-index-container"};